import { Form } from 'formik';
import type { FC } from 'react';
import UniversityInformation from './components/university-information';
import UniversityAddress from './components/university-address';
import UniversityContactInformation from './components/university-contact-information';
import UniversityLogo from './components/university-logo';

const CreateUniversityForm: FC = () => {
  return (
    <Form className='space-y-4 p-4'>
      <UniversityInformation />
      <UniversityAddress />
      <UniversityContactInformation />
      <UniversityLogo />
    </Form>
  );
};

export default CreateUniversityForm;
